// src/components/Navbar.js

import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/Login");
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container">
        <Link className="navbar-brand" to="/Dashboard">
          Sistema
        </Link>
        <div>
          <Link className="btn btn-outline-light mx-2" to="/Customers">
            Clientes
          </Link>
          <Link className="btn btn-outline-light mx-2" to="/CustomerSystem">
            Systems - Clientes
          </Link>
          <button className="btn btn-danger" onClick={handleLogout}>
            Sair
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
